import { render, staticRenderFns } from "./cardHeader-editor.vue?vue&type=template&id=14773e70&scoped=true"
import script from "./cardHeader-editor.vue?vue&type=script&lang=js"
export * from "./cardHeader-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14773e70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14773e70')) {
      api.createRecord('14773e70', component.options)
    } else {
      api.reload('14773e70', component.options)
    }
    module.hot.accept("./cardHeader-editor.vue?vue&type=template&id=14773e70&scoped=true", function () {
      api.rerender('14773e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/cardHeader-editor.vue"
export default component.exports